// Refactor 02/2026 — extrahiert aus AppointmentsPage.js (Geburtstag-Banner).
import React from 'react';

export const BirthdayBanner = ({ birthdays }) => {
  if (!birthdays || birthdays.length === 0) return null;

  return (
    <div
      className="bg-gradient-to-r from-pink-100 to-pink-50 border-2 border-pink-300 rounded-lg p-4 shadow-md"
      data-testid="birthday-banner"
    >
      <div className="flex items-center gap-3">
        <div className="text-4xl">🎂</div>
        <div className="flex-1">
          <h3 className="text-lg font-bold text-pink-800 mb-1">Geburtstage heute!</h3>
          <div className="space-y-1">
            {birthdays.map((birthday, idx) => (
              <p key={idx} className="text-pink-700 font-medium">
                🎉 <span className="font-bold">{birthday.name}</span> wird heute{' '}
                <span className="font-bold">{birthday.age} Jahre</span> alt!
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BirthdayBanner;
